// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xEGqfCy{display:flex;flex-direction:column;padding:1.5em;border-radius:1em;background:#fff}.Y8Q5nJ_,.xEGqfCy .Y8Q5nJ_{margin-bottom:1.5em;font-family:var(--display-font-family);font-size:1.25em;font-weight:600}@media(max-width: 899px){.Y8Q5nJ_,.xEGqfCy .Y8Q5nJ_{margin-bottom:1.2em;font-size:1em}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `xEGqfCy`,
	"title": `Y8Q5nJ_`
};
export default ___CSS_LOADER_EXPORT___;
